/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TransientCalculationPoint } from './TransientCalculationPoint';
/**
 * Drive Cycle in Database.
 */
export type DriveCycleInDB = {
    item_type?: DriveCycleInDB.item_type;
    name?: string;
    points?: Array<TransientCalculationPoint>;
    _id?: string;
    id?: string; // TODO: This is required
};
export namespace DriveCycleInDB {
    export enum item_type {
        DRIVE_CYCLE = 'drive_cycle',
    }
}

